function initializeSwiper() {
  var swiper = new Swiper(".uswiper", {
    effect: "fade",
    loop: true,
    grabCursor: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
  });
}
initializeSwiper();

document.addEventListener("DOMContentLoaded", function() {
  const videoWrappers = document.querySelectorAll('.u-yt-vid-video-warpper');
  
  videoWrappers.forEach(function(videoWrapper) {
    const iframe = videoWrapper.querySelector('.product-video');
  
    videoWrapper.addEventListener('mouseenter', function() {
      // Add autoplay to the iframe URL when hovered
      let videoUrl = iframe.src;
      if (!videoUrl.includes("autoplay=1")) {
        iframe.src = videoUrl + (videoUrl.includes('?') ? '&' : '?') + 'autoplay=1';
      }
    });
  
    videoWrapper.addEventListener('mouseleave', function() {
      // Remove autoplay from the iframe URL when hover ends
      let videoUrl = iframe.src.replace('&autoplay=1', '').replace('?autoplay=1', '');
      iframe.src = videoUrl; // Reset iframe src without autoplay
    });
  });
});